module.exports = __webpack_public_path__ + "static/media_and_news_no_image-af11fcd35406b871ca235912215401cf.png";